import { ChevronDown } from 'lucide-react'
import { DateTime } from 'luxon'
import { DateRangePicker, type DatePreset } from '~/components/ui/date-range-picker'
import { frenchDateOfIso } from '~/lib/iso-date'
import type { LogisticsSearch } from '~/routes/_authenticated/logistics/-search-schema'
import { parseLocalDate, toIsoDate } from '~/utils/dates/local-date'
import { LOGISTICS_FILTER_CHIP } from './logistics-styles'

const presets: DatePreset<'all'>[] = [
  {
    value: 'all',
    label: 'Toutes les dates',
    // Le DS utilise from: null pour son choix sans borne ; ici ce choix efface les deux bornes.
    getRange: () => ({ from: null, to: DateTime.now().toJSDate() }),
  },
]

/** Une période choisie puis appliquée, ou aucune ; même barre sur la liste et le détail. */
export function LogisticsPeriodFilter({
  search,
  onSearchChange,
}: {
  search: LogisticsSearch
  onSearchChange: (patch: Partial<LogisticsSearch>) => void
}) {
  const from = search.from ? parseLocalDate(search.from) : null
  const to = search.to ? parseLocalDate(search.to) : DateTime.now().toJSDate()
  const label =
    search.from && search.to
      ? `${frenchDateOfIso(search.from)} - ${frenchDateOfIso(search.to)}`
      : 'Période'

  return (
    <DateRangePicker
      value={{ from, to }}
      activePreset={from === null ? 'all' : null}
      presets={presets}
      className={LOGISTICS_FILTER_CHIP}
      triggerContent={() => (
        <>
          <span>{label}</span>
          <ChevronDown className="size-4 shrink-0" />
        </>
      )}
      onChange={(range) =>
        onSearchChange({
          from: range.from ? toIsoDate(range.from) : undefined,
          to: range.from ? toIsoDate(range.to) : undefined,
        })
      }
    />
  )
}
